import * as yup from 'yup';
import { useState } from 'react';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Slide } from 'react-awesome-reveal';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAppSelector } from '../../../../../app/redux/hooks';
import sectionConstants from '../constants/SectionConstants';
import CustomButton from '../../../../components/buttons/CustomButton';
import { Box, Stack, Typography, Dialog, Link as NavLink, Grid } from '@mui/material';
import CustomTextField from '../../../../components/customized/customtextfield/CustomTextField';
import PhoneNoTextField from '../../../../components/customized/customtextfield/PhoneNoTextField';
import { HashLink } from 'react-router-hash-link';
import './FooterSection.scss';
import CalendarDemo from '../demo/CalendarDemo';

const Footer = () => {
  const [open, setOpen] = useState(false);
  const themes = useAppSelector(state => state.theme.theme);

  const schema = yup.object().shape({
    name: yup
      .string()
      .required('Enter Name')
      .matches(/^[A-Za-z-]+(\s*[A-Za-z-]+)*$/, 'Enter valid name')
      .min(2, 'Too Short!'),
    organisation: yup
      .string()
      .required('Enter the Organisation')
      .matches(/^[A-Za-z.-]+(\s*[A-Za-z.-]+)*$/, 'Enter valid organisation')
      .min(4, 'Too Short!'),
    emailID: yup
      .string()
      .required('Enter Email ID')
      .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, 'Enter valid email')
      .email('Enter valid email'),
    message: yup
      .string()
      .required('Enter the Message')
      .matches(/^[A-Za-z .-]+(\s*[A-Za-z .-]+)*$/, 'Enter valid message')
      .min(5, 'Too Short!'),
    designation: yup
      .string()
      .required('Enter designation')
      .matches(/^[A-Za-z.-]+(\s*[A-Za-z.-]+)*$/, 'Enter valid designation')
      .min(4, 'Too Short!')
  });

  const { control, handleSubmit, reset } = useForm({ resolver: yupResolver(schema) });

  const [contactNumber, setContactNumber] = useState<string>('');
  const [error, setError] = useState<boolean>(false);

  const handlePhoneNoError = () => {
    if (contactNumber !== '') {
      setError(false);
    } else setError(true);
  };

  const handlePhoneNo = (value: any) => {
    if (value.length > 5) {
      setContactNumber(value);
      setError(false);
    } else setContactNumber('');
  };

  const onSubmit = async (params: any) => {
    handlePhoneNoError();
    if (contactNumber !== '') {
      params.phoneNo = contactNumber;
      setContactNumber('');
      setError(false);
    } else setError(true);
  };

  const footerFun = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
    setError(false);
    setContactNumber('');
    reset();
  };

  return (
    <Box>
      <Box className='footer-section-image'>
        <Slide>
          <Stack
            className='footer-heading'
            alignItems='center'
            direction='row'
            justifyContent='center'
          >
            {sectionConstants.Discoverthepowerofefficient}
            <br />
            {sectionConstants.Demo}

            <CalendarDemo />

            {/* <Icon
              icon='majesticons:arrow-right'
              onClick={footerFun}
              className='footer-icon'
            /> */}
          </Stack>
        </Slide>
      </Box>
      <Box className='footer-bg-image'>
        <Box pt='7%'>
          <Stack direction='row'>
            <Box width='43%'>
              <Typography className='footer-content'>
                {sectionConstants.QuickLinks}
              </Typography>
              <HashLink smooth to='/about#top'>
                <Typography className='footer-data '>
                  {sectionConstants.AboutUss}
                </Typography>
              </HashLink>
              <HashLink smooth to='/contact#top'>
                <Typography className='footer-data '>
                  {sectionConstants.ContactUss}
                </Typography>
              </HashLink>
              <HashLink smooth to='/privacypolicy#top'>
                <Typography className='footer-data '>
                  {sectionConstants.PrivacyPolicy}
                </Typography>
              </HashLink>
              <HashLink smooth to='/terms&conditions#top'>
                <Typography className='footer-data '>
                  {sectionConstants.TermsConditions}
                </Typography>
              </HashLink>
            </Box>
            <Box width='48%'>
              <Typography className='footer-content'>
                {sectionConstants.ContactUss}
              </Typography>

              <NavLink
                href={
                  themes === 'ayka'
                    ? 'https://maps.app.goo.gl/YPVTHSVr78cgp38aA'
                    : 'https://goo.gl/maps/smWnpVCztncGGFWX9'
                }
                target='_blank'
              >
                <Stack spacing={2} direction='row'>
                  <Icon icon='gis:location-poi' className='location-icon' />
                  <Typography className='footer-data'>
                    {sectionConstants.Address}
                  </Typography>
                </Stack>
              </NavLink>

              <NavLink href={`tel:${sectionConstants.mobilenumber}`}>
                <Stack spacing={2} direction='row'>
                  <Icon icon='ion:call' className='icon-style' />
                  <Typography className='footer-data'>
                    {sectionConstants.mobilenumber}
                  </Typography>
                </Stack>
              </NavLink>

              <NavLink href={`mailto:${sectionConstants.email}`}>
                <Stack spacing={2} direction='row'>
                  <Icon icon='formkit:email' className='icon-style' />
                  <Typography className='footer-data'>
                    {sectionConstants.email}
                  </Typography>
                </Stack>
              </NavLink>

              <Stack spacing={2} direction='row' mt={2}>
                <Typography className='footer-data '>
                  {sectionConstants.follow}
                </Typography>
                <NavLink href='https://www.instagram.com' target='_blank'>
                  <Icon icon='bi:instagram' className='icon-style' />
                </NavLink>
                <NavLink href='https://www.youtube.com' target='_blank'>
                  <Icon icon='basil:youtube-solid' className='icon-style' />
                </NavLink>
                <NavLink href='https://www.linkedin.com' target='_blank'>
                  <Icon icon='uil:linkedin' className='icon-style' />
                </NavLink>
              </Stack>
            </Box>
          </Stack>
        </Box>
      </Box>
      {/* {open && <CalendarDemo />} */}
      <Dialog
        open={open}
        maxWidth='md'
        className='dialog'
        onClose={() => setOpen(false)}
        aria-labelledby='alert-dialog-title'
        fullWidth
        aria-describedby='alert-dialog-description'
      >
        <Box className='dialog'>
          <Stack direction='row' spacing={1} padding={'20px 24px 15px'}>
            <Typography className='typo1'>{sectionConstants.ScheduleA}</Typography>
            <Typography className='typo2'>{sectionConstants.Demo}</Typography>
          </Stack>
          <Grid
            container
            spacing={2}
            component='form'
            padding={'5px 24px 24px 24px'}
            onSubmit={handleSubmit(onSubmit)}
          >
            <Grid item md={4} sm={12} xs={12}>
              <CustomTextField
                label='Name'
                control={control}
                name='name'
                id='demo-name'
                placeholder='Name'
                inputProps={{
                  maxLength: 30
                }}
              />
            </Grid>

            <Grid item md={4} sm={12} xs={12}>
              <CustomTextField
                label='Organisation'
                control={control}
                name='organisation'
                id='demo-organisation'
                placeholder='Organisation'
                inputProps={{
                  maxLength: 20
                }}
              />
            </Grid>

            <Grid item md={4} sm={12} xs={12}>
              <CustomTextField
                label='Email ID'
                control={control}
                name='emailID'
                id='demo-emailID'
                placeholder='Email ID'
                inputProps={{
                  maxLength: 60
                }}
              />
            </Grid>

            <Grid item md={4} sm={12} xs={12}>
              <PhoneNoTextField
                label='Mobile Number'
                id='demo-contactNumber'
                onChange={handlePhoneNo}
                error={error}
              />
            </Grid>

            <Grid item md={4} sm={12} xs={12}>
              <CustomTextField
                label='Message'
                control={control}
                name='message'
                id='demo-message'
                placeholder='Message'
                inputProps={{
                  maxLength: 50
                }}
              />
            </Grid>

            <Grid item md={4} sm={12} xs={12}>
              <CustomTextField
                label='Designation'
                control={control}
                name='designation'
                id='demo-designation'
                placeholder='Designation'
                inputProps={{
                  maxLength: 20
                }}
              />
            </Grid>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                marginTop: '8px',
                justifyContent: 'right',
                width: '100%'
              }}
            >
              <CalendarDemo />
              <CustomButton className='cancel' category='Cancel' onClick={onClose} />
              <Box sx={{ marginLeft: '12px' }}>
                <CustomButton
                  className='saveChanges'
                  category=' Submit'
                  type='submit'
                  sx={{ color: 'white', alignSelf: 'flex-start' }}
                  onClick={handlePhoneNoError}
                />
              </Box>
            </Box>
          </Grid>
        </Box>
      </Dialog>
    </Box>
  );
};

export default Footer;
